import React from 'react';

import { useApp } from '../../store/AppContext';

export default function TimelineViewControls() {
  const { setTimelineGroupBy, setTimelineZoom, timelineGroupBy, timelineZoom } = useApp();
  return (
    <div className="flex justify-end gap-[8px] items-center">
      <select
        value={timelineZoom}
        onChange={(e) => setTimelineZoom(e.target.value)}
        className="input select w-auto h-[34px] text-[12.5px] py-[5px] pl-[10px] rounded-[9px]"
      >
        <option value="jour">Jours</option>
        <option value="semaine">Semaines</option>
        <option value="mois">Mois</option>
      </select>
      <div className="flex rounded-[20px] overflow-hidden [border:1.5px_solid_#023848]">
        <button
          onClick={() => setTimelineGroupBy('dev')}
          className={`[border:none] text-[12.5px] py-[5px] px-[16px] cursor-pointer [font-family:inherit] whitespace-nowrap ${timelineGroupBy === 'dev' ? 'bg-navy text-white font-semibold' : 'bg-white text-navy font-medium'}`}
        >
          Par dev
        </button>
        <button
          onClick={() => setTimelineGroupBy('proj')}
          className={`[border:none] [border-left:1.5px_solid_#023848] text-[12.5px] py-[5px] px-[16px] cursor-pointer [font-family:inherit] whitespace-nowrap ${timelineGroupBy === 'proj' ? 'bg-navy text-white font-semibold' : 'bg-white text-navy font-medium'}`}
        >
          Par projet
        </button>
      </div>
    </div>
  );
}
